'use client';

interface BarChartProps {
  data: { label: string; count: number }[];
  color?: string;
  maxBarWidth?: number;
}

export function BarChart({ data, color = '#3b82f6', maxBarWidth = 100 }: BarChartProps) {
  if (data.length === 0) return null;
  const max = Math.max(...data.map((d) => d.count));

  return (
    <div className="space-y-1.5">
      {data.map(({ label, count }) => {
        const pct = max > 0 ? (count / max) * maxBarWidth : 0;
        return (
          <div key={label} className="flex items-center gap-2 text-xs">
            <span className="w-36 shrink-0 text-slate-500 truncate text-right text-[11px]" title={label}>
              {label}
            </span>
            <div className="flex-1 bg-slate-100 rounded-full overflow-hidden h-4 relative">
              <div
                className="h-4 rounded-full transition-all duration-500"
                style={{ width: `${pct}%`, background: color }}
              />
            </div>
            <span className="w-6 shrink-0 text-right font-mono font-semibold text-slate-700 text-[11px]">
              {count}
            </span>
          </div>
        );
      })}
    </div>
  );
}
